var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`size-${_vm.size}`},[_c('video-player',{class:{ blur: !_vm.canViewVideo },attrs:{"muted":true,"controls":_vm.canViewVideo,"autoplay":true,"loop":true,"mp4Url":_vm.creatorPost.video.mp4Url,"webmUrl":_vm.creatorPost.video.webmUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }